import { render, staticRenderFns } from "./onlinePaper.vue?vue&type=template&id=3cf144e0&scoped=true"
import script from "./onlinePaper.vue?vue&type=script&lang=js"
export * from "./onlinePaper.vue?vue&type=script&lang=js"
import style0 from "./onlinePaper.vue?vue&type=style&index=0&id=3cf144e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf144e0",
  null
  
)

export default component.exports